<div class="row">
  <app-card type="info"
    borderClass="border-default">
    <div icon-title><span class="fa fa-bookmark-o"></span></div>
    <div left-title>
      <h4 class="mb-0">Service Requests</h4>
    </div>
    <div card-content-container>
      <ul class="ps-4">
        <ng-container>
          <li *ngIf="showSRequests"><a routerLink="/program/service-requests"
              [attr.data-dl]="JSON.stringify({da_track: 'true'})">{{serviceRequestsData1}}</a></li>
          <li *ngIf="showAddNewWCPRequest"><a routerLink="/program/add-new-wc-posting-request"
              [attr.data-dl]="JSON.stringify({da_track: 'true'})">{{serviceRequestsData2}}</a></li>
        </ng-container>
      </ul>
    </div>
  </app-card>
</div>